import {
  ONBOARDING_OUTLINED_INPUT_CLASS_NAME,
  DEFAULT_OUTLINED_INPUT_CLASS_NAME,
  FORM_OUTLINED_INPUT_CLASS_NAME,
  COMPACT_OUTLINED_INPUT_CLASS_NAME,
} from '../../constants/outlined-input';

const onboardingOutlinedInput = ({ theme }) => ({
  height: 50,
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 2,
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.gray.A400,
      borderWidth: 2,
    },
  },
  '& .MuiOutlinedInput-input': {
    fontStyle: 'normal',
    fontWeight: 700,
    paddingLeft: 0,
    fontSize: '14px',
    lineHeight: '24px',
    borderRadius: 'inherit',
  },
  '&.Mui-selected .MuiOutlinedInput-input': {
    fontSize: '20px',
  },
});

const defaultOutlinedInput = ({ theme }) => ({
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
});

export const formOutlinedInput = ({ theme, isSelectedBorderColor }) => ({
  height: 48,
  backgroundColor: 'white',
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: 8,
    borderWidth: 1,
  },
  borderRadius: 8,
  '& .MuiOutlinedInput-input': {
    fontSize: '14px',
    fontWeight: 400,
    paddingLeft: theme.spacing(1),
    borderRadius: 'inherit',
    backgroundColor: 'transparent',
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isSelectedBorderColor,
      borderWidth: 2,
    },
  },
  '&.Mui-selected': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isSelectedBorderColor,
    },
  },
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.palette.error.A600}`,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.gray.A100,
  },
});

const compactOutlinedInput = ({ theme }) => ({
  height: 40,
  borderRadius: 8,
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: 8,
    borderWidth: 1,
  },
  '& .MuiOutlinedInput-input': {
    fontSize: theme.typography.small_2.fontSize,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-root': {
      ...theme.typography.small_2,
      fontWeight: 500,
      color: theme.palette.gray.A500,
    },
  },
  '&.MuiInputBase-multiline': {
    height: 'auto',
    padding: theme.spacing(1.25, 2),
    '& .MuiOutlinedInput-input': {
      padding: 0,
    },
  },
});

const MuiOutlinedInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 30, // 48 in leia
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.gray.A400,
        borderRadius: 8,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.gray.A600}`,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${theme.palette.primary.A500}`,
      },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.error.A600}`,
      },
      '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.error.A600}`,
      },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.gray.A200,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.gray.A100,
        pointerEvents: 'none',
        borderRadius: 8,
        border: `1px solid ${theme.palette.gray.A200}`,
      },
      [`&.${DEFAULT_OUTLINED_INPUT_CLASS_NAME}`]: defaultOutlinedInput({ theme }),
      [`&.${FORM_OUTLINED_INPUT_CLASS_NAME}`]: formOutlinedInput({ theme, isSelectedBorderColor: theme.palette.primary.main }),
      [`&.${ONBOARDING_OUTLINED_INPUT_CLASS_NAME}`]: onboardingOutlinedInput({ theme }),
      [`&.${COMPACT_OUTLINED_INPUT_CLASS_NAME}`]: compactOutlinedInput({ theme }),
    }),
    input: ({ theme }) => ({
      padding: '2px 14px',
      color: theme.palette.gray.A800,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '140%',
      backgroundColor: 'white',
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
        WebkitBackgroundClip: 'text',
      },
      '&.Mui-disabled': {
        color: theme.palette.text.disabled,
        backgroundColor: 'transparent',
      },
    }),
  },
};

export default MuiOutlinedInput;
